module.exports = __webpack_public_path__ + "static/media/2.3572f546.png";